var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf-svgrepo-com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#F15642"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.94531 23.6838C7.94531 23.3538 8.20531 22.9938 8.62406 22.9938H10.9328C12.2328 22.9938 13.4028 23.8638 13.4028 25.5313C13.4028 27.1113 12.2328 27.9913 10.9328 27.9913H9.26406V29.3113C9.26406 29.7513 8.98406 30 8.62406 30C8.29406 30 7.94531 29.7513 7.94531 29.3113V23.6838ZM9.26406 24.2525V26.7425H10.9328C11.6028 26.7425 12.1328 26.1513 12.1328 25.5313C12.1328 24.8325 11.6028 24.2525 10.9328 24.2525H9.26406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.3619 30.0001C15.0319 30.0001 14.6719 29.8201 14.6719 29.3813V23.7038C14.6719 23.3451 15.0319 23.0838 15.3619 23.0838H17.6506C22.2181 23.0838 22.1181 30.0001 17.7406 30.0001H15.3619ZM15.9919 24.3038V28.7813H17.6506C20.3494 28.7813 20.4694 24.3038 17.6506 24.3038H15.9919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.7372 24.3838V25.9725H26.2859C26.6459 25.9725 27.0059 26.3325 27.0059 26.6813C27.0059 27.0113 26.6459 27.2813 26.2859 27.2813H23.7372V29.38C23.7372 29.73 23.4884 29.9988 23.1384 29.9988C22.6984 29.9988 22.4297 29.73 22.4297 29.38V23.7025C22.4297 23.3438 22.6997 23.0825 23.1384 23.0825H26.6472C27.0872 23.0825 27.3472 23.3438 27.3472 23.7025C27.3472 24.0225 27.0872 24.3825 26.6472 24.3825H23.7372V24.3838Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.79e7786d22d18495618828b3e9f869bb.svg";
export { ForwardRef as ReactComponent };